module.exports = __webpack_public_path__ + "static/running_pad.e434a28f.png";